/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Text,
  TextField,
  Button,
  Flex,
  Card,
  ScrollArea,
  Grid,
  Heading,
  Badge,
  Separator,
  Select,
} from "@radix-ui/themes";
import { GeneralContextFunc } from "../Context/GeneralContex";
import {
  updateCompanyDetails,
  getAllCharityData,
  updateContactDetails,
  updateResourceDetails,
  updateResourceLocationDetails,
} from "../Services/DashboardApi";
import { useLocation, useNavigate } from "react-router-dom";

const ComunityBox = (props) => {
  console.log(props, "PROPS")
  const navigate = useNavigate();
  const location = useLocation();
  const [CompanyDetails, setCompanyDetails] = useState({});
  const [ContactDetails, setContactDetails] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    title: "",
    userId: "",
  });
  const [ResourceDetails, setResourceDetails] = useState({
    legalName: "",
    dbaTradeName: "",
    businessType: "",
    resourceType: "",
    industrySector: "",
    einTaxId: "",
    businessLicense: "",
    isVerified: false,
    isDeleted: false,
  });
  
  const [ResourceLocationDetails, setResourceLocationDetails] = useState([]);
  
  // Business types array
  const businessTypes = [
    "Sole Proprietorship",
    "Partnership", 
    "LLC (Limited Liability Company)",
    "Corporation",
    "501(c)(3) Nonprofit",
    "Other 501(c) Organization",
    "Government Agency / Department",
    "School or Educational Institution",
    "Religious Organization",
    "Unincorporated Group / Association",
    "Other (please specify)"
  ];

  // Resource types array
  const resourceTypes = [
    { id: "Charity", label: "🏛️ Charitable Organization / Nonprofit" },
    { id: "LocalTown", label: "🏢 Local Town / City / Government Department" },
    { id: "SmallBusiness", label: "🛍️ Small Business / Company" },
    { id: "Individual", label: "👤 Individual / Family / Community Member" }
  ];

  // Industry sectors array
  const industrySectors = [
  "Agriculture (farming, crops, agribusiness, co-ops)",
  "Forestry (timber, forest management, conservation)",
  "Fishing & Aquaculture (fisheries, aquaculture, seafood)",
  "Mining (coal, minerals, precious metals)",
  "Metals (steel, aluminum, industrial metals)",
  "Oil (exploration, drilling, refining, petroleum)",
  "Gas (natural gas, LNG, pipelines)",
  "Renewable Energy (solar, wind, hydro, geothermal, clean energy)",
  "Chemicals (industrial chemicals, fertilizers, plastics, coatings)",
  "Materials (paper, glass, textiles, raw materials)",
  "Manufacturing (consumer goods, machinery, electronics, food production)",
  "Industrial Equipment (tools, heavy machinery, industrial systems)",
  "Aerospace (airlines, aviation services, aircraft manufacturing)",
  "Defense (military contractors, weapons, security systems)",
  "Construction (building contractors, real estate development)",
  "Engineering (civil, mechanical, electrical, structural)",
  "Real Estate (residential housing, commercial properties)",
  "Property Management (leasing, facilities management, housing associations)",
  "Electricity (generation, grids, utilities)",
  "Water (supply, sanitation, treatment)",
  "Waste Management (recycling, hazardous waste, sanitation services)",
  "Transportation (public transit, buses, taxis, ride-share, rail)",
  "Logistics (shipping, freight, warehousing, supply chain)",
  "Maritime & Ports (shipping lines, ports, fisheries logistics)",
  "Automotive (car sales, auto parts, repair shops)",
  "Wholesale Trade (distributors, suppliers, B2B trade)",
  "Retail Trade (grocery stores, shops, boutiques, malls, e-commerce)",
  "Restaurants (restaurants, cafés, diners, food stalls)",
  "Beverage Services (bars, pubs, coffee shops, breweries, wineries)",
  "Fashion & Apparel (clothing brands, footwear, tailoring, textiles)",
  "Consumer Goods (household products, electronics, appliances)",
  "Events & Experiences (wedding planners, fairs, festivals, expos, entertainment venues)",
  "Finance (banking, investment, fintech, venture capital)",
  "Insurance (life, health, property, casualty)",
  "Professional Services (consulting, law, accounting, HR, recruiting)",
  "Administrative Services (outsourcing, BPO, office support, facilities management)",
  "Business Support & Trade Associations (chambers of commerce, trade orgs, industry bodies)",
  "Information Technology (IT services, system integration, cloud)",
  "Software Development (apps, SaaS, enterprise software)",
  "Telecommunications (internet providers, mobile carriers, satellites)",
  "Artificial Intelligence (AI platforms, robotics, automation)",
  "Data & Analytics (big data, business intelligence, cybersecurity)",
  "Machine Learning (predictive analytics, AI startups, applied ML)",
  "Blockchain (DLT technology, smart contracts)",
  "Cryptocurrency (exchanges, wallets, DeFi, NFTs)",
  "Media (newspapers, publishing, journalism, digital media)",
  "Broadcasting (TV, radio, streaming services)",
  "Communications (public relations, corporate communications)",
  "Arts (visual arts, galleries, literature, performance art)",
  "Culture (museums, heritage, cultural groups, preservation)",
  "Entertainment (film, music, gaming, performing arts)",
  "Design (fashion, graphic design, interior design, photography)",
  "Marketing & Advertising (brand management, creative agencies, social media)",
  "Education (primary, K–12, tutoring)",
  "Higher Education (universities, colleges, technical schools)",
  "Research & Development (labs, think tanks, science institutes, innovation hubs)",
  "Libraries & Knowledge Services (public libraries, archives, information services)",
  "Healthcare (hospitals, clinics, doctors, nursing care)",
  "Pharmaceuticals (drug manufacturing, distribution)",
  "Biotechnology (genomics, medical research, biotech startups)",
  "Medical Devices & Equipment (suppliers, manufacturers)",
  "Wellness (mental health, therapy, nutrition, holistic health, fitness)",
  "Government (federal, state, local authorities)",
  "Public Administration (municipal services, city planning)",
  "Nonprofits (charities, aid organizations, advocacy groups)",
  "Foundations (grantmakers, philanthropic trusts)",
  "Faith-Based Organizations (churches, mosques, temples, spiritual orgs)",
  "Community Organizations (neighborhood groups, civic associations, youth groups)",
  "Labor Unions & Worker Associations (trade unions, guilds, employee co-ops)",
  "Veteran Services (rehab, housing, veteran programs)",
  "Military Support (active duty family support, bases, defense families)",
  "First Responder Services (police, fire, EMS, disaster relief)",
  "Sports (pro teams, amateur leagues, school athletics)",
  "Fitness (gyms, trainers, studios, personal training)",
  "Recreation (parks, hobby groups, outdoor clubs)",
  "Tourism (travel agencies, tour operators, destinations)",
  "Hospitality (hotels, resorts, guesthouses, hostels)",
  "Personal Services (barbers, salons, spas, beauty services)",
  "Household Services (cleaning, repairs, childcare, domestic workers)",
  "Homemakers (stay-at-home parents, family caretakers)",
  "Domestic Work (nannies, housekeepers, informal work)",
  "Gig Economy (delivery, ride-share, platform-based services)",
  "Freelance Work (independent professionals, consultants, creatives)",
  "Influencer Economy (YouTubers, streamers, podcasters)",
  "Creator Economy (independent content, Patreon, Substack, bloggers)"
  ];

  const { setloader, initAlert } = GeneralContextFunc();
  const [charityList, setCharityList] = useState([]);
  const [showCharityList, setShowCharityList] = useState(false);

  const getCharityData = () => {
    setloader(true);
    getAllCharityData()
      .then((res) => {
        console.log(res, "CHARITY DATA");
        setCharityList(res?.sortedData);
        // initAlert(res?.message);
        setloader(false);
      })
      .catch((err) => {
        console.log(err);
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    let data = props?.companyDetails;
    console.log(data, "DATA")
    setCompanyDetails({ ...data[0] });
    if (data[0]?.resourceName === "Charity") getCharityData();
  }, [props?.companyDetails]);

  console.log(ResourceLocationDetails, "RESOURCE LOCATION DETAILS")

  useEffect(() => {
    // Map contactDetails from props
    if (props?.contactDetails) {
      setContactDetails(props.contactDetails);
    }
  }, [props?.contactDetails]);

  useEffect(() => {
    // Map resourceDetails from props
    if (props?.resourceDetails) {
      setResourceDetails(props.resourceDetails);
    }
  }, [props?.resourceDetails]);

  useEffect(() => {
    // Map resourceLocationDetails from props
    if (props?.resourceLocationDetails) {
      setResourceLocationDetails(props.resourceLocationDetails);
    }
  }, [props?.resourceLocationDetails]);

  const changeCommunity = (event) => {
    let { name, value } = event.target;
    setCompanyDetails({ ...CompanyDetails, [name]: value });
  };

  const changeContactDetails = (event) => {
    let { name, value } = event.target;
    setContactDetails({ ...ContactDetails, [name]: value });
  };

  const changeResourceDetails = (event) => {
    let { name, value } = event.target;
    setResourceDetails({ ...ResourceDetails, [name]: value });
  };

  const changeResourceLocationDetails = (locationIndex, field, value) => {
    const updatedLocations = [...ResourceLocationDetails];
    updatedLocations[locationIndex] = {
      ...updatedLocations[locationIndex],
      [field]: value
    };
    setResourceLocationDetails(updatedLocations);
  };

  const changeResourceLocationAddress = (locationIndex, addressType, field, value) => {
    const updatedLocations = [...ResourceLocationDetails];
    if (!updatedLocations[locationIndex][addressType]) {
      updatedLocations[locationIndex][addressType] = {};
    }
    updatedLocations[locationIndex][addressType] = {
      ...updatedLocations[locationIndex][addressType],
      [field]: value
    };
    setResourceLocationDetails(updatedLocations);
  };

  const saveBtn = () => {
    setloader(true);
    let payload = CompanyDetails;
    payload.id = location.state.id;
    let data = props?.companyDetails;
    if (data[0]?.resourceName === "Charity") {
      payload.resourceId = CompanyDetails.id;
    }
    updateCompanyDetails(payload)
      .then((res) => {
        initAlert(res?.message);
        const { getCampaignDataById } = props;
        let payload = {
          id: location.state.id,
        };
        getCampaignDataById(payload);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  const saveContactDetails = () => {
    setloader(true);
    
    // Prepare the payload for the API
    const payload = {
      contactId: ContactDetails?.id || ContactDetails?.userId || "",
      firstName: ContactDetails?.firstName || "",
      lastName: ContactDetails?.lastName || "",
      title: ContactDetails?.title || "",
      phoneNumber: ContactDetails?.phoneNumber || "",
      emailAddress: ContactDetails?.emailAddress || ""
    };

    updateContactDetails(payload)
      .then((res) => {
        setloader(false);
        initAlert(res?.message || "Contact details saved successfully!");
        // Optionally refresh the data
        const { getCampaignDataById } = props;
        if (getCampaignDataById) {
          let refreshPayload = {
            id: location.state.id,
          };
          getCampaignDataById(refreshPayload);
        }
      })
      .catch((err) => {
        setloader(false);
        if (err.response?.data?.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Failed to save contact details. Please try again.", "error");
      });
  };

  const saveResourceDetails = () => {
    setloader(true);
    
    // Prepare the payload for the API
    const payload = {
      resourceId: ResourceDetails?.id || ResourceDetails?.userId || "",
      legalName: ResourceDetails?.legalName || "",
      dbaTradeName: ResourceDetails?.dbaTradeName || "",
      businessType: ResourceDetails?.businessType || "",
      resourceType: ResourceDetails?.resourceType || "",
      industrySector: ResourceDetails?.industrySector || "",
      einTaxId: ResourceDetails?.einTaxId || "",
      businessLicense: ResourceDetails?.businessLicense || "",
      isVerified: ResourceDetails?.isVerified || false
    };

    updateResourceDetails(payload)
      .then((res) => {
        setloader(false);
        initAlert(res?.message || "Resource details saved successfully!");
        // Optionally refresh the data
        const { getCampaignDataById } = props;
        if (getCampaignDataById) {
          let refreshPayload = {
            id: location.state.id,
          };
          getCampaignDataById(refreshPayload);
        }
      })
      .catch((err) => {
        setloader(false);
        if (err.response?.data?.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Failed to save resource details. Please try again.", "error");
      });
  };

  const saveResourceLocationDetails = () => {
    setloader(true);
    
    // Prepare the payload for the API
    const payload = {
      locationId: ResourceLocationDetails[0]?.id || "",
      contactPersonName: ResourceLocationDetails[0]?.contactPersonName || "",
      contactPhone: ResourceLocationDetails[0]?.contactPhone || "",
      address: ResourceLocationDetails[0]?.address || {},
      shippingAddress: ResourceLocationDetails[0]?.shippingAddress || {}
    };

    updateResourceLocationDetails(payload)
      .then((res) => {
        setloader(false);
        initAlert(res?.message || "Resource location details saved successfully!");
        // Optionally refresh the data
        const { getCampaignDataById } = props;
        if (getCampaignDataById) {
          let refreshPayload = {
            id: location.state.id,
          };
          getCampaignDataById(refreshPayload);
        }
      })
      .catch((err) => {
        setloader(false);
        if (err.response?.data?.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Failed to save resource location details. Please try again.", "error");
      });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-8">
      {/* Header Section */}
      <div className="mb-8">
        <Heading size="6" className="text-gray-900 font-semibold mb-2">
          Community Details
        </Heading>
        <Text size="3" className="text-gray-600">
          Manage contact and resource information
        </Text>
      </div>

      {/* Contact Details Section */}
      <Card className="p-6 bg-white shadow-sm border border-gray-200">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="w-1 h-8 bg-blue-500 rounded-full mr-4"></div>
            <Heading size="4" className="text-gray-900 font-semibold">
              Contact Details
            </Heading>
          </div>
          <Button 
            size="2" 
            onClick={() => saveContactDetails()} 
            className="px-4 py-2 bg-blue-600 hover:bg-green-600 text-white font-medium rounded-lg transition-colors shadow-sm"
          >
            Save Contact Details
          </Button>
        </div>
        
        <Grid columns="2" gap="4">
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              First Name
            </Text>
            <TextField.Root
              value={ContactDetails?.firstName || ""}
              onChange={(e) => changeContactDetails(e)}
              name="firstName"
              variant="soft"
              className="w-full"
              placeholder="Enter first name"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Last Name
            </Text>
            <TextField.Root
              value={ContactDetails?.lastName || ""}
              onChange={(e) => changeContactDetails(e)}
              name="lastName"
              variant="soft"
              className="w-full"
              placeholder="Enter last name"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Email Address
            </Text>
            <TextField.Root
              value={ContactDetails?.emailAddress || ""}
              onChange={(e) => changeContactDetails(e)}
              name="emailAddress"
              variant="soft"
              className="w-full"
              placeholder="Enter email address"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Phone Number
            </Text>
            <TextField.Root
              value={ContactDetails?.phoneNumber || ""}
              onChange={(e) => changeContactDetails(e)}
              name="phoneNumber"
              variant="soft"
              className="w-full"
              placeholder="Enter phone number"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Title
            </Text>
            <TextField.Root
              value={ContactDetails?.title || ""}
              onChange={(e) => changeContactDetails(e)}
              name="title"
              variant="soft"
              className="w-full"
              placeholder="Enter title"
            />
          </div>
        </Grid>
      </Card>

      {/* Resource Details Section */}
      <Card className="p-6 bg-white shadow-sm border border-gray-200">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="w-1 h-8 bg-green-500 rounded-full mr-4"></div>
            <Heading size="4" className="text-gray-900 font-semibold">
              Resource Details
            </Heading>
          </div>
          <Button 
            size="2" 
            onClick={() => saveResourceDetails()} 
            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors shadow-sm"
          >
            Save Resource Details
          </Button>
        </div>
        
        <Grid columns="2" gap="4">
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Legal Name
            </Text>
            <TextField.Root
              value={ResourceDetails?.legalName || ""}
              onChange={(e) => changeResourceDetails(e)}
              name="legalName"
              variant="soft"
              className="w-full"
              placeholder="Enter legal name"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              DBA/Trade Name
            </Text>
            <TextField.Root
              value={ResourceDetails?.dbaTradeName || ""}
              onChange={(e) => changeResourceDetails(e)}
              name="dbaTradeName"
              variant="soft"
              className="w-full"
              placeholder="Enter DBA/trade name"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Business Type
            </Text>
            <select
              value={ResourceDetails?.businessType || ""}
              onChange={(e) => changeResourceDetails({ target: { name: "businessType", value: e.target.value } })}
              className="w-full h-10 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm"
            >
              <option value="">Choose business type...</option>
              {businessTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Resource Type
            </Text>
            <select
              value={ResourceDetails?.resourceType || ""}
              onChange={(e) => changeResourceDetails({ target: { name: "resourceType", value: e.target.value } })}
              className="w-full h-10 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm"
            >
              <option value="">Select resource type</option>
              {resourceTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Industry Sector
            </Text>
            <select
              value={ResourceDetails?.industrySector || ""}
              onChange={(e) => changeResourceDetails({ target: { name: "industrySector", value: e.target.value } })}
              className="w-full h-10 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm"
            >
              <option value="">Select industry sector...</option>
              {industrySectors.map((sector) => (
                <option key={sector} value={sector}>
                  {sector}
                </option>
              ))}
            </select>
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              EIN/Tax ID
            </Text>
            <TextField.Root
              value={ResourceDetails?.einTaxId || ""}
              onChange={(e) => changeResourceDetails(e)}
              name="einTaxId"
              variant="soft"
              className="w-full"
              placeholder="Enter EIN/tax ID"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Business License
            </Text>
            <TextField.Root
              value={ResourceDetails?.businessLicense || ""}
              onChange={(e) => changeResourceDetails(e)}
              name="businessLicense"
              variant="soft"
              className="w-full"
              placeholder="Enter business license"
            />
          </div>
          
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Verification Status
            </Text>
            <div className="flex items-center gap-2">
              <TextField.Root
                value={ResourceDetails?.isVerified ? "Verified" : "Not Verified"}
                variant="soft"
                className="w-full"
                readOnly
              />
              <Badge variant="soft" color={ResourceDetails?.isVerified ? "green" : "red"} size="1">
                {ResourceDetails?.isVerified ? "Verified" : "Not Verified"}
              </Badge>
            </div>
          </div>
        </Grid>
      </Card>

      {/* Resource Location Details Section */}
      {ResourceLocationDetails && ResourceLocationDetails.length > 0 && (
        <Card className="p-6 bg-white shadow-sm border border-gray-200">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div className="w-1 h-8 bg-yellow-500 rounded-full mr-4"></div>
              <Heading size="4" className="text-gray-900 font-semibold">
                Resource Location Details
              </Heading>
            </div>
            <Button 
              size="2" 
              onClick={() => saveResourceLocationDetails()} 
              className="px-4 py-2 bg-yellow-600 hover:bg-green-600 text-white font-medium rounded-lg transition-colors shadow-sm"
            >
              Save Resource Location Details
            </Button>
          </div>
          
          <div className="space-y-6">
            {ResourceLocationDetails.map((location, index) => (
              <div key={location.id || index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                <div className="flex items-center justify-between mb-4">
                  <Text size="3" className="font-semibold text-gray-900">
                    Location {index + 1}
                  </Text>
                 
                </div>
                
                <Grid columns="2" gap="4">
                  {/* Contact Person Information */}
                  <div className="space-y-2">
                    <Text size="2" className="text-gray-700 font-medium">
                      Contact Person Name
                    </Text>
                    <TextField.Root
                      value={location.contactPersonName || ""}
                      onChange={(e) => changeResourceLocationDetails(index, "contactPersonName", e.target.value)}
                      variant="soft"
                      className="w-full"
                      placeholder="Enter contact person name"
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Text size="2" className="text-gray-700 font-medium">
                      Contact Phone
                    </Text>
                    <TextField.Root
                      value={location.contactPhone || ""}
                      onChange={(e) => changeResourceLocationDetails(index, "contactPhone", e.target.value)}
                      variant="soft"
                      className="w-full"
                      placeholder="Enter contact phone number"
                    />
                  </div>
                </Grid>
                
                {/* Address Details */}
                <div className="mt-6">
                  <Text size="3" className="font-semibold text-gray-900 mb-3">
                    Address Information
                  </Text>
                  
                  <Grid columns="2" gap="4">
                    <div className="space-y-2">
                      <Text size="2" className="text-gray-700 font-medium">
                        Street Address
                      </Text>
                      <TextField.Root
                        value={location.address?.streetAddress || ""}
                        onChange={(e) => changeResourceLocationAddress(index, "address", "streetAddress", e.target.value)}
                        variant="soft"
                        className="w-full"
                        placeholder="Enter street address"
                      />
                    </div>
                    
                    <div className="space-y-2">
                      <Text size="2" className="text-gray-700 font-medium">
                        City
                      </Text>
                      <TextField.Root
                        value={location.address?.city || ""}
                        onChange={(e) => changeResourceLocationAddress(index, "address", "city", e.target.value)}
                        variant="soft"
                        className="w-full"
                        placeholder="Enter city"
                      />
                    </div>
                    
                    <div className="space-y-2">
                      <Text size="2" className="text-gray-700 font-medium">
                        State
                      </Text>
                      <TextField.Root
                        value={location.address?.state || ""}
                        onChange={(e) => changeResourceLocationAddress(index, "address", "state", e.target.value)}
                        variant="soft"
                        className="w-full"
                        placeholder="Enter state"
                      />
                    </div>
                    
                    <div className="space-y-2">
                      <Text size="2" className="text-gray-700 font-medium">
                        Zip Code
                      </Text>
                      <TextField.Root
                        value={location.address?.zipCode || ""}
                        onChange={(e) => changeResourceLocationAddress(index, "address", "zipCode", e.target.value)}
                        variant="soft"
                        className="w-full"
                        placeholder="Enter zip code"
                      />
                    </div>
                    
                    <div className="space-y-2">
                      <Text size="2" className="text-gray-700 font-medium">
                        Country
                      </Text>
                      <TextField.Root
                        value={location.address?.country || ""}
                        onChange={(e) => changeResourceLocationAddress(index, "address", "country", e.target.value)}
                        variant="soft"
                        className="w-full"
                        placeholder="Enter country"
                      />
                    </div>
                  </Grid>
                </div>
                
                {/* Shipping Address Details */}
                {location.shippingAddress && (
                  <div className="mt-6">
                    <Text size="3" className="font-semibold text-gray-900 mb-3">
                      Shipping Address
                    </Text>
                    
                    <Grid columns="2" gap="4">
                      <div className="space-y-2">
                        <Text size="2" className="text-gray-700 font-medium">
                          Street Address
                        </Text>
                        <TextField.Root
                          value={location.shippingAddress?.streetAddress || ""}
                          onChange={(e) => changeResourceLocationAddress(index, "shippingAddress", "streetAddress", e.target.value)}
                          variant="soft"
                          className="w-full"
                          placeholder="Enter shipping street address"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <Text size="2" className="text-gray-700 font-medium">
                          City
                        </Text>
                        <TextField.Root
                          value={location.shippingAddress?.city || ""}
                          onChange={(e) => changeResourceLocationAddress(index, "shippingAddress", "city", e.target.value)}
                          variant="soft"
                          className="w-full"
                          placeholder="Enter shipping city"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <Text size="2" className="text-gray-700 font-medium">
                          State
                        </Text>
                        <TextField.Root
                          value={location.shippingAddress?.state || ""}
                          onChange={(e) => changeResourceLocationAddress(index, "shippingAddress", "state", e.target.value)}
                          variant="soft"
                          className="w-full"
                          placeholder="Enter shipping state"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <Text size="2" className="text-gray-700 font-medium">
                          Zip Code
                        </Text>
                        <TextField.Root
                          value={location.shippingAddress?.zipCode || ""}
                          onChange={(e) => changeResourceLocationAddress(index, "shippingAddress", "zipCode", e.target.value)}
                          variant="soft"
                          className="w-full"
                          placeholder="Enter shipping zip code"
                        />
                      </div>
                      
                      <div className="space-y-2">
                        <Text size="2" className="text-gray-700 font-medium">
                          Country
                        </Text>
                        <TextField.Root
                          value={location.shippingAddress?.country || ""}
                          onChange={(e) => changeResourceLocationAddress(index, "shippingAddress", "country", e.target.value)}
                          variant="soft"
                          className="w-full"
                          placeholder="Enter shipping country"
                        />
                      </div>
                    </Grid>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Card>
      )}

      {/* Company Details Section */}
      {CompanyDetails?.resourceName === "Small Business" && (
        <Card className="p-6 bg-white shadow-sm border border-gray-200">
          <div className="flex items-center mb-6">
            <div className="w-1 h-8 bg-purple-500 rounded-full mr-4"></div>
            <Heading size="4" className="text-gray-900 font-semibold">
              Business Details
            </Heading>
          </div>
          
          <Grid columns="2" gap="4">
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Name of Business
              </Text>
              <TextField.Root
                value={CompanyDetails?.name || ""}
                onChange={(e) => changeCommunity(e)}
                name="name"
                variant="soft"
                className="w-full"
                placeholder="Enter business name"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                EIN Number
              </Text>
              <TextField.Root
                value={CompanyDetails?.TINorEIN || ""}
                onChange={(e) => changeCommunity(e)}
                name="TINorEIN"
                variant="soft"
                className="w-full"
                placeholder="Enter EIN number"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Phone
              </Text>
              <TextField.Root
                value={CompanyDetails?.phone || ""}
                onChange={(e) => changeCommunity(e)}
                name="phone"
                variant="soft"
                className="w-full"
                placeholder="Enter phone number"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Email
              </Text>
              <TextField.Root
                value={CompanyDetails?.email || ""}
                onChange={(e) => changeCommunity(e)}
                name="email"
                variant="soft"
                className="w-full"
                placeholder="Enter email address"
              />
            </div>
          </Grid>
        </Card>
      )}

      {CompanyDetails?.resourceName === "Charity" && (
        <Card className="p-6 bg-white shadow-sm border border-gray-200">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div className="w-1 h-8 bg-orange-500 rounded-full mr-4"></div>
              <Heading size="4" className="text-gray-900 font-semibold">
                Charity Details
              </Heading>
            </div>
            <Button 
              size="2" 
              variant="soft"
              onClick={() => setShowCharityList(!showCharityList)}
              className="text-blue-600 hover:text-blue-700"
            >
              {showCharityList ? "Cancel" : "Change"}
            </Button>
          </div>
          
          {!showCharityList ? (
            <Card className="p-4 bg-gray-50 border border-gray-200">
              <Text size="3" className="font-semibold text-gray-900 mb-1">
                {CompanyDetails?.name} [
                {CompanyDetails?.isVerified ? "Verified" : "Not Verified"}]
              </Text>
              <Text size="2" className="text-gray-600">
                {CompanyDetails?.categoryName} | {CompanyDetails?.location} |
                EIN: {CompanyDetails?.TINorEIN}
              </Text>
            </Card>
          ) : (
            <ScrollArea
              size="1"
              scrollbars="vertical"
              type="always"
              className="max-h-48 border border-gray-200 rounded-lg"
            >
              <div className="p-2 space-y-2">
                {charityList.map((data, i) => (
                  <Card
                    key={i}
                    className="p-3 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      setCompanyDetails({ ...data });
                      setShowCharityList(false);
                    }}
                  >
                    <Text size="2" className="font-semibold text-gray-900">
                      {data?.name} [
                      {data?.isVerified ? "Verified" : "Not Verified"}]
                    </Text>
                    <Text size="1" className="text-gray-600">
                      {data?.categoryName} | {data?.location} | EIN:{" "}
                      {data?.TINorEIN}
                    </Text>
                  </Card>
                ))}
              </div>
            </ScrollArea>
          )}
        </Card>
      )}

      {CompanyDetails?.resourceName === "Local Community" && (
        <Card className="p-6 bg-white shadow-sm border border-gray-200">
          <div className="flex items-center mb-6">
            <div className="w-1 h-8 bg-indigo-500 rounded-full mr-4"></div>
            <Heading size="4" className="text-gray-900 font-semibold">
              Community Details
            </Heading>
          </div>
          
          <Grid columns="2" gap="4">
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Name of Business
              </Text>
              <TextField.Root
                value={CompanyDetails?.name || ""}
                onChange={(e) => changeCommunity(e)}
                name="name"
                variant="soft"
                className="w-full"
                placeholder="Enter business name"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                EIN Number
              </Text>
              <TextField.Root
                value={CompanyDetails?.TINorEIN || ""}
                onChange={(e) => changeCommunity(e)}
                name="TINorEIN"
                variant="soft"
                className="w-full"
                placeholder="Enter EIN number"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Phone
              </Text>
              <TextField.Root
                value={CompanyDetails?.phone || ""}
                onChange={(e) => changeCommunity(e)}
                name="phone"
                variant="soft"
                className="w-full"
                placeholder="Enter phone number"
              />
            </div>
            
            <div className="space-y-2">
              <Text size="2" className="text-gray-700 font-medium">
                Email
              </Text>
              <TextField.Root
                value={CompanyDetails?.email || ""}
                onChange={(e) => changeCommunity(e)}
                name="email"
                variant="soft"
                className="w-full"
                placeholder="Enter email address"
              />
            </div>
          </Grid>
        </Card>
      )}

      {/* Save Button - Only for Company Details */}
      {CompanyDetails?.resourceName && (
        <div className="flex justify-end pt-6">
          <Button 
            size="3" 
            onClick={() => saveBtn()} 
            className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors shadow-sm"
          >
            Save Company Details
          </Button>
        </div>
      )}
    </div>
  );
};

export default ComunityBox;
